import React, { useEffect, useState } from "react";
import { WorkerInfo } from "IF/interfaceType";
import { Button, Grid2, Stack, TextField } from "@mui/material";
import { useThemeMode } from "Contexts/ThemeContext";

interface ResultFormProps {
  data: WorkerInfo;
  index?: number;
  inputFlg: boolean;
  onInput?: (inputData: WorkerInfo) => void;
  onUpdate?: (updatedData: WorkerInfo) => void;
  onDelete?: (updatedData: WorkerInfo) => void;
  openModal: (message: string, confirmAction: () => void) => void;
}

export const SettingWorkerForm: React.FC<ResultFormProps> = ({
  data,
  index,
  inputFlg,
  onInput,
  onUpdate,
  onDelete,
  openModal,
}) => {
  const [formData, setFormData] = useState<WorkerInfo>(data);
  const { mode } = useThemeMode();
  useEffect(() => {
    setFormData(data);
  }, [data]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleClick = () => {
    if (onInput) {
      // onInputが存在する場合に実行
      onInput(formData);
    } else if (onUpdate) {
      onUpdate(formData);
    } else {
      console.warn("No action is assigned.");
    }
  };

  const handleOpenModal = () => {
    openModal("選択した作業者情報を削除します。よろしいですか？", () =>
      onDelete?.(data)
    );
  };

  return (
    <>
      <Stack direction="column" spacing={2}>
        <Grid2>
          <TextField
            fullWidth
            label="作業者名"
            name="name"
            inputProps={{ maxLength: 30 }}
            value={formData.name}
            onChange={handleChange}
          />
        </Grid2>
        <Grid2>
          <TextField
            fullWidth
            label="作業開始日"
            name="startDate"
            type="date"
            value={formData.startDate}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            sx={{
              input: {
                placeholder: "",
                ...(mode === "dark" && {
                  "&::-webkit-calendar-picker-indicator": {
                    filter: "invert(1)",
                  },
                }),
              },
            }}
          />
        </Grid2>
        <Grid2>
          <TextField
            fullWidth
            label="作業開始時間"
            name="startTime"
            type="time"
            value={formData.startTime}
            onChange={handleChange}
            sx={{
              input: {
                placeholder: "",
                ...(mode === "dark" && {
                  "&::-webkit-calendar-picker-indicator": {
                    filter: "invert(1)",
                  },
                }),
              },
            }}
            InputLabelProps={{ shrink: true }}
          />
        </Grid2>
        <Grid2>
          <TextField
            fullWidth
            label="作業終了日"
            name="endDate"
            type="date"
            value={formData.endDate}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            sx={{
              input: {
                placeholder: "",
                ...(mode === "dark" && {
                  "&::-webkit-calendar-picker-indicator": {
                    filter: "invert(1)",
                  },
                }),
              },
            }}
          />
        </Grid2>
        <Grid2>
          <TextField
            fullWidth
            label="作業終了時間"
            name="endTime"
            type="time"
            value={formData.endTime}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            sx={{
              input: {
                placeholder: "",
                ...(mode === "dark" && {
                  "&::-webkit-calendar-picker-indicator": {
                    filter: "invert(1)",
                  },
                }),
              },
            }}
          />
        </Grid2>
        <Grid2>
          {inputFlg ? (
            <Grid2 size={{ xs: 12, sm: 12 }}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleClick}
              >
                新規登録
              </Button>
            </Grid2>
          ) : (
            <Grid2
              container
              spacing={1}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid2 size={{ xs: 6, sm: 6 }}>
                <Button
                  fullWidth
                  variant="contained"
                  style={{ backgroundColor: "#000080" }}
                  onClick={handleClick}
                >
                  更新
                </Button>
              </Grid2>
              <Grid2 size={{ xs: 6, sm: 6 }}>
                <Button
                  fullWidth
                  variant="contained"
                  color="error"
                  onClick={() => handleOpenModal()}
                >
                  削除
                </Button>
              </Grid2>
            </Grid2>
          )}
        </Grid2>
      </Stack>
    </>
  );
};
